<div fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row">
   Dodaj plik
  </div>

  <div fxLayout="row" >

    <app-file-drag-and-drop
      fxFlex="100"
      [multiple]="false"
      [generateOutput]="true"
      (fileSelected)="fileSelected($event)"
      [required]="true"
      [maxSize]="fileMaxSize"
      acceptMime="*/*"
    ></app-file-drag-and-drop>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <span fxFlex></span>

    <button
      mat-raised-button (click)="sendForm()" color="primary"
      [class.spinner]="processingRequest" [disabled]="processingRequest || !enableSaveButton"
    >Zapisz</button>
    <button (click)="closeDialog($event)" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
